import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { PopupNotificationMarks } from '../../../const';
import {
  MarkPopupNotificationDisplayedMutation,
  MarkPopupNotificationDisplayedMutationVariables,
} from '../../../data-access/gql-types/graphql';
import { MARK_POPUP_NOTIFICATION_DISPLAYED } from '../../../data-access/mutations/user';
import { useUserProfileStore } from '../../../store/user-profile';

export const useSetEvaluateDialogTimeStart = () => {
  const [markPopupAsDisplayed] = useMutation<
    MarkPopupNotificationDisplayedMutation,
    MarkPopupNotificationDisplayedMutationVariables
  >(MARK_POPUP_NOTIFICATION_DISPLAYED);
  const refetchUserProfile = useUserProfileStore((s) => s.refetchUserProfile);
  const { profileData } = useUserProfileStore((s) => s);

  useEffect(() => {
    if (profileData?.popupNotificationMarks) {
      const popupNotificationMarks = profileData.popupNotificationMarks;
      const evaluateDialogTimeStart = popupNotificationMarks.find(
        (x) => x.key === PopupNotificationMarks.EvaluateDialogTimeStart,
      );

      if (!evaluateDialogTimeStart) {
        markPopupAsDisplayed({
          variables: {
            input: {
              mark: {
                at: new Date(),
                key: PopupNotificationMarks.EvaluateDialogTimeStart,
              },
            },
          },
          onCompleted: () => {
            refetchUserProfile();
          },
        });
      }
    }
  }, [profileData?.popupNotificationMarks]);
};
